<template>
  <StandardButton
    v-bind="buttonProps"
    @click="toggleIsMenuShown"
  >
    <template
      v-if="buttonProps.icon"
      #icon
    >
      <slot name="icon" />
    </template>
  </StandardButton>
  <!-- Cannot use StandardMenu here because we need to fully control the container and its styling.
       Cannot use StandardPopover here because we don't want to have an arrow, etc -->
  <PVPopover
    ref="popoverRef"
    :pt="passThroughPropsPopover"
    unstyled
  >
    <StandardMenu
      v-bind="menuProps"
      :pt="passThroughPropsMenu"
    >
      <template #start>
        <li role="presentation">
          <form class="b-dropdown-form">
            <StandardInputText
              v-model="model"
              :size="'sm'"
              autofocus
            />
          </form>
        </li>
        <li role="presentation">
          <hr
            role="separator"
            aria-orientation="horizontal"
            class="dropdown-divider mb-0"
          />
        </li>
      </template>
    </StandardMenu>
  </PVPopover>
</template>
<script lang="ts">
export default {
  name: 'StandardButtonWithSearchableMenu',
  compatConfig: { MODE: 3 },
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import type PVPopover from 'primevue/popover';
import type { StandardButtonProps } from '@/components/standard-components/StandardButton.vue';
import type { StandardMenuProps } from '@/components/standard-components/StandardMenu.vue';

const model = defineModel<string>({ required: true });

defineProps<{
  buttonProps: StandardButtonProps;
  menuProps: StandardMenuProps;
}>();

const popoverRef = ref<InstanceType<typeof PVPopover> | null>(null);
const toggleIsMenuShown = async (e: MouseEvent) => {
  popoverRef.value?.toggle(e);
};

const passThroughPropsPopover = {
  root: {
    class: 'dropdown-menu shadow show pb-0 rounded',
  },
};
const passThroughPropsMenu = {
  list: {
    class: 'scroll-md pl-0 rounded mb-0',
  },
};
</script>
